import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('certifyai_user') || 'null');
        } catch {
            return null;
        }
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('certifyai_token');
        if (token && !user) {
            api.get('/auth/me').then((r) => {
                setUser(r.data);
                localStorage.setItem('certifyai_user', JSON.stringify(r.data));
            }).catch(() => {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const login = async (email, password) => {
        setLoading(true);
        try {
            const { data } = await api.post('/auth/login', { email, password });
            if (data.mfa_required) {
                // Iter 90 · admin con 2FA activo: aún no hay sesión, solo un
                // challenge de corta duración que se canjea en completeMfaLogin.
                return { mfaRequired: true, mfaChallenge: data.mfa_challenge };
            }
            localStorage.setItem('certifyai_token', data.access_token);
            localStorage.setItem('certifyai_user', JSON.stringify(data.user));
            setUser(data.user);
            return data.user;
        } finally {
            setLoading(false);
        }
    };

    const completeMfaLogin = async (mfaChallenge, code) => {
        setLoading(true);
        try {
            const { data } = await api.post('/auth/login/mfa', { mfa_challenge: mfaChallenge, code });
            localStorage.setItem('certifyai_token', data.access_token);
            localStorage.setItem('certifyai_user', JSON.stringify(data.user));
            setUser(data.user);
            return data.user;
        } finally {
            setLoading(false);
        }
    };

    const register = async (payload) => {
        setLoading(true);
        try {
            const { data } = await api.post('/auth/register', { ...payload, role: 'client' });
            localStorage.setItem('certifyai_token', data.access_token);
            localStorage.setItem('certifyai_user', JSON.stringify(data.user));
            setUser(data.user);
            return data.user;
        } finally {
            setLoading(false);
        }
    };

    const logout = () => {
        localStorage.removeItem('certifyai_token');
        localStorage.removeItem('certifyai_user');
        setUser(null);
        window.location.href = '/';
    };

    const updateUser = (next) => {
        setUser(next);
        try {
            localStorage.setItem('certifyai_user', JSON.stringify(next));
        } catch {}
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, completeMfaLogin, register, logout, setUser: updateUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
